var render = function() {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c(
    "div",
    { staticClass: "commodity-list" },
    [
      _vm.titleType
        ? _c("div", { staticClass: "returned-title medium" }, [
            _c("span", [_vm._v("The following items need to be returned")]),
            _vm._v(" "),
            _vm.serviceOrderDetail.length > 0
              ? _c("span", { staticClass: "returned-title-icon" }, [
                  _vm.collapse
                    ? _c("i", {
                        staticClass: "el-icon-arrow-down",
                        on: { click: _vm.open }
                      })
                    : _vm._e(),
                  _vm._v(" "),
                  !_vm.collapse
                    ? _c("i", {
                        staticClass: "el-icon-arrow-up",
                        on: { click: _vm.open }
                      })
                    : _vm._e()
                ])
              : _vm._e()
          ])
        : _vm._e(),
      _vm._v(" "),
      _c("el-collapse-transition", [
        _c(
          "div",
          {
            directives: [
              {
                name: "show",
                rawName: "v-show",
                value: _vm.collapse,
                expression: "collapse"
              }
            ]
          },
          _vm._l(_vm.serviceOrderDetail, function(item, index) {
            return _c(
              "div",
              { key: index, staticClass: "commodity-list-content" },
              [
                _c("div", { staticClass: "commodity-list-content-top" }, [
                  _c("div", { staticClass: "commodity-list-img" }, [
                    _c("img", {
                      attrs: { src: item.serviceOrderDetailSkuVO.skuImg }
                    })
                  ]),
                  _vm._v(" "),
                  _c("div", { staticClass: "commodity-list-text" }, [
                    _c("div", { staticClass: "commodity-text-title medium" }, [
                      _vm._v(_vm._s(item.serviceOrderDetailSkuVO.skuName))
                    ]),
                    _vm._v(" "),
                    _c("div", { staticClass: "commodity-text-type" }, [
                      _c("span", [
                        _vm._v(_vm._s(item.serviceOrderDetailSkuVO.skuParam))
                      ]),
                      _vm._v(" "),
                      _c("span", { staticClass: "commodity-text-type-order" }, [
                        _vm._v(_vm._s(item.serviceOrderDetailSkuVO.skuCode))
                      ])
                    ]),
                    _vm._v(" "),
                    _c("div", { staticClass: "commodity-text-ins" }, [
                      _c("div", { staticClass: "commodity-text-ins-price" }, [
                        _c("span", [_vm._v("Price")]),
                        _c("span", [
                          _vm._v(_vm._s(item.serviceOrderDetailSkuVO.unitPrice))
                        ])
                      ]),
                      _vm._v(" "),
                      _c("div", { staticClass: "commodity-text-ins-qty" }, [
                        _c("span", [_vm._v("Qty")]),
                        _c("span", [
                          _vm._v(
                            _vm._s(
                              item["serviceOrderDetailSkuVO"]
                                ? item["serviceOrderDetailSkuVO"]["num"]
                                : 0
                            )
                          )
                        ])
                      ]),
                      _vm._v(" "),
                      _c(
                        "div",
                        { staticClass: "commodity-text-ins-refundable" },
                        [
                          _c("span", [_vm._v("Refundable Refund Qty")]),
                          _vm._v(" "),
                          _c("span", [_vm._v(_vm._s(item.refundableRetundQty))])
                        ]
                      ),
                      _vm._v(" "),
                      _c("div", { staticClass: "commodity-text-ins-return" }, [
                        _c("span", [_vm._v("Return Qty")]),
                        _vm._v(" "),
                        _c("span", [_vm._v(_vm._s(item.returnQty))])
                      ])
                    ])
                  ])
                ]),
                _vm._v(" "),
                item.refundDesc
                  ? _c(
                      "div",
                      { staticClass: "commodity-list-content-description" },
                      [
                        _c(
                          "div",
                          { staticClass: "commodity-description-title" },
                          [
                            _vm._v(
                              "Refund description " + _vm._s(item.refundDesc)
                            )
                          ]
                        )
                      ]
                    )
                  : _vm._e(),
                _vm._v(" "),
                _c("div", { staticClass: "commodity-list-content-swiper" }, [
                  _c("div", { staticClass: "commodity-swiper-title" }, [
                    _c("span", [_vm._v("Upload picture certificate")]),
                    _vm._v(" "),
                    _vm.edit
                      ? _c(
                          "span",
                          { staticClass: "commodity-swiper-up-limit" },
                          [_vm._v("Up to 10 images")]
                        )
                      : _vm._e()
                  ]),
                  _vm._v(" "),
                  _c(
                    "div",
                    { staticClass: "commodity-swiper" },
                    [
                      _c("img-swiper", {
                        attrs: {
                          edit: _vm.edit,
                          imgListMessage: _vm.getImgList(
                            item.serviceOrderFeedbackPicList
                          )
                        }
                      })
                    ],
                    1
                  )
                ])
              ]
            )
          }),
          0
        )
      ])
    ],
    1
  )
}
var staticRenderFns = []
render._withStripped = true
var esExports = { render: render, staticRenderFns: staticRenderFns }
export default esExports
if (module.hot) {
  module.hot.accept()
  if (module.hot.data) {
    require("vue-hot-reload-api")      .rerender("data-v-9589aeae", esExports)
  }
}


//////////////////
// WEBPACK FOOTER
// ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-9589aeae","hasScoped":true,"transformToRequire":{"video":["src","poster"],"source":"src","img":"src","image":"xlink:href"},"buble":{"transforms":{}}}!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/pages/order/service-order/components/commodity-list.vue
// module id = H9Po
// module chunks = 2